export const PersonMenuItemKey = {
  // Overview
  PERSON_DETAILS: 'person-details',
  NAMES: 'names',

  // Identity & Bio
  FEATURES: 'features',
  PHOTO: 'photo',
  SMT_RECORDS: 'smt-records',
  DNA_SAMPLES: 'dna-samples',
  CREDENTIAL: 'credential',

  // Contacts & Network
  ADDRESSES: 'addresses',
  CONTACT_METHODS: 'contact-methods',
  ASSOCIATE: 'associate',
  EMPLOYMENT: 'employment',
  VEHICLE_REGISTRATIONS: 'vehicle-registrations',
  RELATED_RECORDS: 'related-records',
  ATTACHMENTS: 'attachments',
  SOPS: 'sops',
  HISTORY: 'history',
  TAGS: 'tags',
  BULLETINS: 'bulletins',
};
